<template>
  <v-container fluid>
    <v-row>
      <v-card v-for="image in list(optionId)" :key="image.id" width="200" class="ml-2 mr-2">
        <v-img :src="$assets.url(image.file.thumbnailUrl)" height="150px" width="200px" />
        <v-card-actions>
          <v-btn icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn icon @click="submitDelete(image)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn icon>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-col cols="3">
        <file-upload v-model="uploadFile" @uploaded="submitUploaded()"></file-upload>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FileUpload from "@/components/FileUpload.vue";
export default {
  components: {
    FileUpload
  },
  data: () => ({
    uploadFile: null
  }),
  props: {
    optionId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters("optionImage", ["list"])
  },
  mounted() {
    this.initialize();
  },

  beforeDestroy() {
    this.clean();
  },
  methods: {
    ...mapActions("optionImage", {
      getList: "list",
      create: "create",
      clean: "clean",
      delete: "delete"
    }),
    initialize() {
      this.getList(this.optionId);
    },
    submitUploaded() {
      this.create({
        option_id: this.optionId,
        file_id: this.uploadFile.id,
        order: 0
      }).finally(() => {
        this.uploadFile = null;
      });
    },
    submitDelete(image) {
      this.delete({ option_id: this.optionId, id: image.id });
    }
  }
};
</script>

<style>
</style>